{
    "EmailRule_Failed": "E-Mail muss gültig sein",
    "NAME": "GenericRuleLanguage"
}